import NoteStatus from "../../../model/NoteStatus";
import RemarkType from "../../../model/RemarkType";
import User from "../../../model/User";

import Color from "../colors/Color";

import Dot from "./Dot";
import DotComment from "./DotComment";

export default class ApprovalPendingDot implements ApprovalPendingDotData {
    _id: string;
    creator: User;
    status: NoteStatus;
    comments: DotComment[];
    dotType: RemarkType.ApprovalNote;
    approvalsId: string;
    color: Color;
    name: string;
    x: number;
    y: number;

    constructor(dot: ApprovalPendingDotData) {
        this.name = dot.name;
        this.dotType = RemarkType.ApprovalNote;
        this.approvalsId = dot.approvalsId;
        this.color = dot.color;
        this.x = dot.x;
        this.y = dot.y;
        this._id = `${dot._id.replace("new", "approvalsPending")}`;
        this.creator = new User(window.Zeplin.user);
        this.status = NoteStatus.OPEN;
        this.comments = [
            {
                ...dot.comments[0],
                _id: `${dot._id.replace("new", "approvalsPending")}`,
                created: new Date().toString(),
                updated: new Date().toString(),
                author: new User(window.Zeplin.user)
            }
        ];
    }
}

export interface ApprovalPendingDotData extends Dot {
    dotType: RemarkType.ApprovalNote;
    approvalsId: string;
}
